<!--
 * @Description:服务管理服务项目服务套餐
 * @Author:sunhuihong
 * @Date: 2022-05-23 14:43:52
 * @LastEditTime: 2024-01-04 14:54:45
-->
<template>
  <div class="view-hsvcmng-service-package">
    <el-form  class="form"  ref="pkgCfgForm" :model="pkgCfgForm" :rules="rules" label-position="left">
       <el-row style="margin: 30px 25px; padding-top: 30px;" :gutter="0" type="flex"  justify="space-between">
        <el-col :span="17" >
          <div class="service-sharing" v-if="0">
            <div class="head">
              <span class="title-tag"></span>
              <span class="head-title">服务分成</span>
              <el-popover placement="top" title="" width="200" trigger="hover"
                content="收付通管理/商户列表-分账设置模块已设置分成比例，若本服务分成比例不同，请在此处设置">
                <span slot="reference">
                  <img style="width: 18px; height: 18px; margin-left: 11px; vertical-align: middle;" 
                    src="@/assets/common/icon-common-question-mark.png" alt="">
                </span>
              </el-popover>
            </div>
            <el-form-item class="sharing-content" v-if="serviceRevenueSharingCfgList.length" prop="checkSharingType">
              <el-checkbox-group v-model="pkgCfgForm.checkSharingType" :min="0" :max="2" style="width : 260px;" @change="changeSharingType">
                <el-checkbox v-for="(item,index) in serviceRevenueSharingCfgList" :label="item.type" :key="index" 
                  :disabled="item.type == 3 || readonly || !hsvcSharingPrivilege.canSharingCfg" 
                  style="display: block; margin-bottom: 8px;">
                  <span class="sharing-content-label" :style="{'color': item.type != 3 ? '#657180' : '#B6BDCE',
                    'margin-left': item.type != 3 ? '0': '-12px'}">
                    {{item.type == 1 ? '本平台' : item.type == 2 ? '机构' : item.type == 3 ? '个人' : '' }}
                  </span>
                  <span  v-if="item.type != 3" >:</span>
                  <el-input v-if="item.type != 3" style="width: 160px; margin-left: 8px;"  maxlength="5" size="small"  
                    v-model="item.ratioStr" :disabled="readonly || !hsvcSharingPrivilege.canSharingCfg" 
                    :readonly="readonly" @input="inputServiceSharingRatio(item.ratioStr,index)">
                    <template slot="append">
                      <span style="padding: 0 10px">%</span>
                    </template>
                  </el-input>
                  <span v-else>(派单人、接单人、代理人等)</span>
                </el-checkbox>
              </el-checkbox-group>
              <div class="sharing-content-delete" >               
                <el-button style="color: #F33A3A; font-size: 20px;" type="text" :disabled="readonly || !hsvcSharingPrivilege.canSharingCfg"  
                  icon="el-icon-delete" @click="deleteSetSharingRate" >
                </el-button>
               </div>
            </el-form-item>
            <el-button v-else style="width: 260px; height: 46px; margin-top: 15px;" type="primary" 
              :disabled="readonly || !hsvcSharingPrivilege.canSharingCfg" icon="el-icon-circle-plus-outline"  
              @click="handleSetSharingRate">
              设置分成比例
            </el-button>
          </div>
          <el-row type="flex" justify="space-between">
            <div class="head">
              <span class="title-tag"></span>
              <span class="head-title">套餐</span>
            </div>
            <el-button size="medium" :disabled="readonly"  @click="handleAddSetMeal" type="text"  
              icon="el-icon-circle-plus-outline" style="float: right; color: #3A7FF3;">
              新增新套餐
            </el-button>          
          </el-row>
          <div style="border: 1px solid #ccc; padding: 15px 30px 30px 16px; margin: 5px 0 10px 0;" 
            v-for="(item,index) in pkgCfgForm.servicePkgCfgList" :key="index">
            <el-row type="flex" justify="space-between" style="margin-bottom: 27px;">
              <el-col :span="12">
                <span class="title-name">套餐{{index+1}}</span>
              </el-col>
              <el-col :span="12" style="text-align: right;" 
                v-if="pkgCfgForm.servicePkgCfgList && pkgCfgForm.servicePkgCfgList.length > 1">
                <el-button style="color: #F33A3A; padding: 0;" type="text"  :disabled="readonly" 
                  icon="el-icon-delete" @click.native="deleteHservicePackage(item, index)">
                  删除套餐
                </el-button>
              </el-col>
            </el-row>
            <el-row >
              <el-col :span="16" >
                <el-form-item label="服务套餐:" label-width="82px" :prop="'servicePkgCfgList.'+index+'.name'" :rules="[
                { required: true, message: '请输入套餐名称', trigger: 'blur' },
                { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }]">
                  <el-input v-model.trim="item.name" size="small" :disabled="readonly" :readonly="readonly" 
                    placeholder="请输入套餐名称" >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row  type="flex"  justify="space-between" >
              <el-col :span="8">
                <el-form-item label="服务现价:" label-width="82px" :prop="`servicePkgCfgList.${index}.curPriceYuan`" 
                  :rules="rules.curPriceYuan">
                  <el-input  v-model="item.curPriceYuan" placeholder="服务现价"  size="small"  :disabled="readonly" >
                    <template slot="append">
                      <div style="padding: 0 10px">元/次</div>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8" style="margin: 0 20px;">
                <el-form-item label="服务原价:" label-width="82px" :prop="`servicePkgCfgList.${index}.originalPriceYuan`" 
                  :rules="rules.originalPriceYuan"  >
                  <el-input  v-model="item.originalPriceYuan" placeholder="服务原价"  size="small"  :disabled="readonly" 
                    :readonly="readonly">
                    <template slot="append" >元/次</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="服务时长:" label-width="82px" :prop="`servicePkgCfgList.${index}.serviceDuration`" 
                  :rules="rules.serviceDuration"  >
                  <el-input  v-model="item.serviceDuration" placeholder="请输入"  size="small"  :disabled="readonly" 
                    :readonly="readonly">
                    <template slot="append" >小时</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="add-style" v-if="item.includeAttendantPrice == 0">
              <el-button style="width: 100%; height: 100%;" type="text" icon="el-icon-circle-plus-outline" 
                :disabled="readonly"  @click="handleAddPackageList(index)" >
                新增不同等级护理员服务价格
              </el-button>
            </div>
            <div  class="view-add-attendant-price" v-else>
               <span class="view-add-attendant-price-title">不同等级护理员服务价格:</span>
               <div class="delete-attendant" @click="handleDeleteAttendant(item, index)">               
                  <el-button style="color: #F33A3A;" type="text"  :disabled="readonly" icon="el-icon-delete">
                  </el-button>
               </div>
               <el-row  type="flex"  justify="space-between" style="padding-right: 40px; height: 30px;">
                <el-col :span="8">
                  <el-form-item label="初级护理员:" label-width="90px" >
                    <el-input  v-model="item.primaryPriceYuan" placeholder=""  size="small"  :disabled="true" >
                      <template slot="append">
                        <span style="padding: 0 10px">元</span>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8" style="margin: 0 20px;">
                  <el-form-item label="中级护理员:" label-width="90px"  >
                    <el-input  v-model="item.middlePriceYuan" placeholder=""  size="small"  :disabled="true" >
                      <template slot="append">
                        <span style="padding: 0 10px">元</span>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="高级护理员:" label-width="90px" >
                    <el-input  v-model="item.highPriceYuan" placeholder=""  size="small"  :disabled="true" >
                      <template slot="append">
                        <div style="padding: 0 10px">元</div>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
               </el-row>
            </div>
          </div>
        </el-col>
        <el-col :span="6" >
          <div style="height: 1100px; overflow-y: scroll;">
            <img style="width: 100%;" src="@/assets/hsvccfg/app.png"  alt="">
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div class="bk-wizard-bottons" style="padding-right: 25px;">
      <wizard-buttons :mode="mode" :status="btnStatus" @btnpressed="handleBtnSelection" />
    </div>
  </div>
</template>
<script>
import hserviseStore from './HserviceDetailStore.js';
import Constant from '@/global/Constant.js'
import Util from '@/global/Util.js'

let HserviceListServicePackagePanel=  {
  name: 'HserviceListServicePackagePanel',
  hserviseStore,
  props: ["hsvcId"],
  
  data() {
    let validatePrice= (_rule, value, callback) => {
      let pattern = /^\d+(\.\d{1,2})?$/;
      if (!pattern.test(value)) {
        return callback(new Error('小数点后最多只能输入两位'))
      } else {
        callback()
      }
    };

    let validateServiceDuration= (_rule, value, callback) => {
      let pattern = /^\d*$/;
      if (!pattern.test(value)) {
        return callback(new Error('只能输入整数'))
      } else {
        callback()
      }
    };

		let validateCheckSharingType = (_rule, _value, callback) => {
			if (this.pkgCfgForm.checkSharingType.length == 0) {
        callback(new Error('请设置分账比例！'));
      } else if (this.checkedSharingData.findIndex(item => item.ratioStr == '') !== -1) {
        callback(new Error('分账比例不能为空！'));
      } else if (this.pkgCfgForm.checkSharingType.length) {
        let scaleSum =  this.checkedSharingData.reduce((sum, e) => sum + Number(e.ratioStr || 0), 0);
        console.log(scaleSum)
        if (Number(scaleSum) != Number(this.maxScale)) {
          callback(new Error('分账比例总和必须等于100%！'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      clickIndex: '',
      maxScale: 100,//比例最大不能超过100%
      rules: {
        checkSharingType: [
          { type: 'array', required: true, validator: validateCheckSharingType, trigger: 'blur' }
        ],
        curPriceYuan: [
          { required: true, message: '请输入套餐现价', trigger: 'blur' },
          { validator: validatePrice, trigger: 'change' },
        ],
        originalPriceYuan: [
          { required: true, message: '请输入套餐原价', trigger: 'blur' },
          { validator: validatePrice, trigger: 'change' },
        ],

        serviceDuration: [
          { required: true, message: '请输入服务时长', trigger: 'blur' },
          { validator: validateServiceDuration, trigger: 'change' },
        ],
      },
      showAddPackagePanelDialog: false,
      btnStatus: {'prev': true, 'next': false, 'submit': true}, 
      pkgCfgForm: {
        servicePkgCfgList: hserviseStore.state.servicePkgCfgList,
        checkSharingType: [],//服务分成选中类型
      },
      
      hsvcSharingPrivilege: {},//服务分成权限数据
      sharingTypeList: {},//默认分账比例设置分类数据[{type :''}]
      serviceRevenueSharingCfgList: [],//分账设置集合
      checkedSharingData: [],//选中的比例数据
      institutionId: hserviseStore.state.serviceCfg.institutionId,
    }
  },

  computed: {
    mode() {
      return hserviseStore.state.mode;
    },

    servicePkgData() {
      return hserviseStore.state.servicePkgCfgList;
    },

    readonly() {
      return hserviseStore.state.mode == 'details';
    }  
  },

  methods: {
    //获取服务分成数据
    listHsvcRevenueSharingCfgs() {
      let params = {
        instId: this.institutionId,
        hsvcId: this.hsvcId
      };
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_LIST_HSVC_REVENUE_SHARING_CFGS,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.sharingTypeList = this.rebuildTypeMapToArray(result.data.typeMap);
        if (this.mode !== 'add' && result.data.revenueSharingCfgList.length) {
          this.getEditOrDetailsRevenueSharingData(result.data);
        }
      });
    },

    //获取当前机构的服务分账比例设置权限
    queryHsvcRevenueSharingCfgPrivilege() {
      let params = {instId: this.institutionId};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_HSVC_REVENUE_SARING_CFG_PRIVILEGE,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.hsvcSharingPrivilege = result.data;
        if (!this.hsvcSharingPrivilege.canSelect) return;
        this.listHsvcRevenueSharingCfgs();
      })
    },

    //删除指定服务的分成配置列表
    deleteHsvcRevenueSharingCfgList() {
      let params = {
        instId: this.institutionId,
        hsvcId: this.hsvcId
      };
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_HSVC_REVENUE_SHARING_CFG_LIST,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.listHsvcRevenueSharingCfgs();
      })
    },

    getEditOrDetailsRevenueSharingData(data) {
      let revenueSharingCfgList = this.sharingTypeList.map((item,index) => {
        return {...item, ...data.revenueSharingCfgList[index]};
      });
      console.log(revenueSharingCfgList)
      this.pkgCfgForm.checkSharingType = data.revenueSharingCfgList.map(item => {return item.type});
      this.serviceRevenueSharingCfgList = revenueSharingCfgList;
    },

    //分成比例{}z转[{}]格式
    rebuildTypeMapToArray (data) {
      let scaleSettingsList = [];
      for (let key in data) {
        scaleSettingsList.push({
          hserviceId: this.hsvcId,
          id: '',
          institutionId: this.institutionId,
          ratioStr: '',
          type: Number(key)
        })
      }
      return scaleSettingsList;
    },

    //获取指定机构与服务类型下的数据
    getHsvcTypeData() {
      let params = {
        'institutionId': this.institutionId,
        'category': hserviseStore.state.serviceCfg.category
      };
			let header = this.encryptionUtil.signatureParams(params,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET', 
        url: Constant.URL_OPENING_HSERVICE,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.pkgCfgForm.servicePkgCfgList[this.clickIndex].highPriceYuan = result.data.highPriceYuan;
        this.pkgCfgForm.servicePkgCfgList[this.clickIndex].middlePriceYuan = result.data.middlePriceYuan;
        this.pkgCfgForm.servicePkgCfgList[this.clickIndex].primaryPriceYuan = result.data.primaryPriceYuan;
        this.pkgCfgForm.servicePkgCfgList[this.clickIndex].includeAttendantPrice = 1;
      });
    },

    //新增不同等级护理员服务价格
    handleAddPackageList(index) {
      this.clickIndex = index;
      this.getHsvcTypeData();
    },

    //点击删除护理员价格
    handleDeleteAttendant(_item,index) {
      this.pkgCfgForm.servicePkgCfgList[index].highPriceYuan = '0.0';
      this.pkgCfgForm.servicePkgCfgList[index].middlePriceYuan = '0.0';
      this.pkgCfgForm.servicePkgCfgList[index].primaryPriceYuan = '0.0';
      this.pkgCfgForm.servicePkgCfgList[index].includeAttendantPrice = 0;
    },

    //新增套餐
    handleAddSetMeal() {
      hserviseStore.state.servicePkgCfgList.push({
        name: '',
        curPriceYuan: '',
        originalPriceYuan: '',
        serviceDuration: '',
        includeAttendantPrice: 0,
        highPriceYuan: '0.0',
        middlePriceYuan: '0.0',
        primaryPriceYuan: '0.0',
     })
    },

    //删除服务套餐
    deleteHservicePackage(item, index) {
      if (item.canDeleteHservicePkg && item.canDeleteHservicePkg == 1) {
        this.$message.error('该服务套餐有关联的订单，不可删除');
        return;
      }
      let strMessage = '套餐' + (index + 1) + '将被删除，是否继续删除？'
      this.$confirm(strMessage, '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        hserviseStore.state.servicePkgCfgList.splice(index, 1)
      })
    },

    //设置服务分成
    handleSetSharingRate() {
      this.serviceRevenueSharingCfgList = this.sharingTypeList;
    },

    //删除已经设置设置分成比例
    deleteSetSharingRate() {
      this.serviceRevenueSharingCfgList = [];
      this.pkgCfgForm.checkSharingType = [];
      this.deleteHsvcRevenueSharingCfgList();
    },

    //输入比率(例如22.50)整数位不能大于3位,小数点后2位
    inputServiceSharingRatio(value, index) {
      this.serviceRevenueSharingCfgList[index].ratioStr =  Util.limitInputTwoDecimal(this.commonUtil.filterDigitals(value, ['.']));
      if (index == 0 && parseFloat(this.serviceRevenueSharingCfgList[index].ratioStr) > parseFloat(30)) {
        this.serviceRevenueSharingCfgList[index].ratioStr = '30';
      }
      if (this.serviceRevenueSharingCfgList[index].ratioStr.length > 5) {
        this.serviceRevenueSharingCfgList[index].ratioStr = this.serviceRevenueSharingCfgList[index].ratioStr.slice(0, 5);
      }
      if (parseFloat(this.serviceRevenueSharingCfgList[index].ratioStr) > parseFloat(100)) {
        this.serviceRevenueSharingCfgList[index].ratioStr = '100';
      }
      this.getCheckedSharingData();
    },

    //分账比例改变
    changeSharingType() {
      this.getCheckedSharingData();
      this.$refs.pkgCfgForm.validateField('checkSharingType');
    },

    getCheckedSharingData () {
      this.checkedSharingData = this.serviceRevenueSharingCfgList.filter(item => 
        this.pkgCfgForm.checkSharingType.includes(item.type)
      );    
    },

    //保存或更新指定服务的分成配置列表
    saveOrUpdateHsvcRevenueSharingCfgList() {
      let filterParams = {
        instId: this.institutionId,
        hsvcId: this.hsvcId
      };
      let params = {...filterParams, ...this.checkedSharingData};
			let [header, esParam] = this.encryptionUtil.encryptAndSignBody(params,
				Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
				Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'POST',
        url: Constant.URL_SAVE_OR_UPDATE_HSVC_REVENUE_SHARING_CFG_LIST,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_JSON,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return ;
        }
      })    
    },

    handleBtnSelection(operate) {
      if (this.serviceRevenueSharingCfgList.length == 0) {
        this.checkedSharingData = [];
      } else {
        this.getCheckedSharingData();
      }
      if (this.mode == 'details' || operate != 'next'&& operate != 'add' && operate != 'edit')  {
        this.$emit("panel-operate", operate);
        return true;
      }
      this.$refs.pkgCfgForm.validate((valid) => {
        if (!valid) {
           return false;
        } else {
          if (this.hsvcSharingPrivilege && this.hsvcSharingPrivilege.canSharingCfg) {
            this.saveOrUpdateHsvcRevenueSharingCfgList();
          }
          this.$emit("panel-operate", operate);
          return true;
        }
      });
    },
  },

  mounted() {
    if (this.mode == 'add') return;
    this.queryHsvcRevenueSharingCfgPrivilege();
  },

  destroyed() {
    //销毁的时候同步数据
    hserviseStore.commit('changeServicePkgCfgList', this.servicePkgData);
  },
}
export default HserviceListServicePackagePanel

</script>
<style >
.view-hsvcmng-service-package  .el-input-group__append {
  padding: 0 10px;
}

.view-hsvcmng-service-package .sharing-content .el-input-group__append {
  padding: 0 20px;
}

.view-hsvcmng-service-package .el-input__inner {
  padding: 0 0 0 10px;
}

.view-hsvcmng-service-package .el-form-item__content .el-input-group {
  vertical-align: middle;
}

.view-hsvcmng-service-package .sharing-content .el-checkbox {
  cursor: default;
}
</style>
<style scoped>
.delete-style {
  color:#e04a52;
  width:20px;
  height:20px;
  line-height: 50px;
  margin: 0 10px;
}

.add-style {
  background-color: #EFF5FA; 
  margin: 5px 0 10px 13px; 
  text-align: center; 
  line-height: 24px;
}

.title-tag {
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #2A97FF;
  border-radius: 2px;
  margin-right: 9px;
  vertical-align: middle;
} 

.title-name {
  width: 37px;
  height: 21px;
  line-height: 21px;
  font-size: 15px;
  font-weight: 400;
  color: #000000;
}

.view-add-attendant-price {
  background: #EFF5FA;
  padding: 18px 16px 20px 21px;
  margin-left: 12px;
  position: relative;
}

.view-add-attendant-price-title {
  display: block;
  margin-bottom: 25px;
  font-size: 14px;
  font-weight: 400;
  color: #657180;
}

.delete-attendant {
  width: 30px;
  position: absolute;
  text-align: center;
  top: 30px;
  right: 0;
  margin-right: 18px;
  cursor: pointer;
}

.form {
  margin-bottom: 60px;
}

.service-sharing {
  margin-bottom: 46px;
}

.head {
  display: flex;
  align-items: center;
}

.head-title {
  font-size: 15px;
  font-weight: 600;
  color: #000000;
}

.sharing-content {
  background: #EFF5FA;
  padding: 23px 34px 3px 16px;
  margin-top: 15px;
}

.sharing-content-label {
  display: inline-block;
  width:48px;
  text-align:right;
  color:#657180
}

.sharing-content-delete {
  position : absolute;
  right: 0;
  top: 0;
  margin-top: 40px;
}
</style>





// WEBPACK FOOTER //
// src/components/hsvcmng/components/hservicedetails/ServicePackagePanel.vue